export enum ToothApplianceType {
  PonticSites = 1,
  Clasps = 2,
  Crown = 3,
  SplintCrown = 4,
  Splint = 5,
  Inlay = 6,
  Onlay = 7,
  ShellTemp = 8,
  Wings = 9,
}

export enum ToothConnectorType {
  PermanentClosed = 1,
  Closed = 2,
  Opened = 3,
}

export const ToothApplianceTypeAbbreviation = {
  [ToothApplianceType.PonticSites]: 'P',
  [ToothApplianceType.Crown]: 'C',
  [ToothApplianceType.SplintCrown]: 'C',
  [ToothApplianceType.Splint]: 'C',
  [ToothApplianceType.Inlay]: 'I',
  [ToothApplianceType.Onlay]: 'O',
  [ToothApplianceType.ShellTemp]: 'S',
  [ToothApplianceType.Wings]: 'W',
};
